function initCoupon() {
  $("#coupon_code").keyup(function(){
    $("form.coupon button[type='submit']").attr("disabled", $(this).val().length == 0)
  })
}

export { initCoupon };
